import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import Facade from '@/Facade'

export class IdleState extends BaseState {
    private _isGambleOfferAvailable = false

    private isBuyBonusBlockedByOperator = (): boolean => {
        const operatorFlags = ((Facade as any).operatorFeatureConfig || {}) as Record<string, any>
        const defaults = ((Facade as any).defaultConfig || {}) as Record<string, any>
        return operatorFlags.hideBuyBonus === true || defaults.hideBuyBonus === true
    }

    public begin() {
        if (Facade.isTurboSpin && this._model.spinState.isWinSkipped) {
            this.end()
        }
        GameSignals.spinButtonClicked.connect(this.end)
        GameSignals.changeBet.connect(this._onChangedBet)
        GameSignals.buyBonusClicked.connect(this._onBuyBonusClicked)
        ;(GameSignals as any).gambleOfferAvailabilityChanged?.connect(this._onGambleOfferAvailabilityChanged)
        GameSignals.idle.emit()
    }

    private _onBuyBonusClicked = (_bonusBuyId: number) => {
        if (this.isBuyBonusBlockedByOperator()) {
            return
        }

        const fixedCoinsBet = this._model.fixedCoinsBet
        const fallbackMultiplier = 80
        const price = fixedCoinsBet * fallbackMultiplier

        this._model.bonusBuyBet = this._model.currentBet * (price / fixedCoinsBet)
        this._model.isBuyBonusPending = true
        this._model.buyBonusPickPosition = Math.max(0, _bonusBuyId - 1)
        this.end()
    }

    public end = () => {
        if (Facade.currentState !== GameStatesEnum.IDLE_STATE) {
            return
        }

        if (this._isGambleOfferAvailable) {
            ;(GameSignals as any).requestGambleCollect?.emit()
            return
        }

        this._stateMachine.setState(GameStatesEnum.START_ROUND_STATE)
    }

    public cleanUp() {
        GameSignals.spinButtonClicked.disconnect(this.end)
        GameSignals.changeBet.disconnect(this._onChangedBet)
        GameSignals.buyBonusClicked.disconnect(this._onBuyBonusClicked)
        ;(GameSignals as any).gambleOfferAvailabilityChanged?.disconnect(this._onGambleOfferAvailabilityChanged)
    }

    private _onChangedBet = (bet: number) => {
        this._model.currentBet = bet
    }

    private _onGambleOfferAvailabilityChanged = (isAvailable: boolean) => {
        this._isGambleOfferAvailable = !!isAvailable
    }
}
